export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWPYt2/ffwAHsgM6WG9R0wAAAABJRU5ErkJggg=="